import React from 'react';
import '../pages/Interview.css';
import { Check } from './InterviewIcons';

export const INTERVIEW_STEPPER_LABELS = Object.freeze({
    steps: Object.freeze(['Setup', 'Rules', 'Practice', 'Interview']),
    progress: 'Interview progress',
});

/**
 * Persistent wizard chrome: the four interview phases rendered as a restrained
 * stepper at PAGE level — between the page header and each pre-interview stage
 * card, aligned to the card's content width on the page background (a subtle
 * baseline hairline, no card border). `activeIndex` is 0-based; earlier steps
 * render as completed (check), later ones as upcoming. Under the mobile
 * breakpoint only markers + the active label remain (CSS).
 * Every string is a display label: `labels` is shallow-merged over
 * INTERVIEW_STEPPER_LABELS, so callers that pass nothing render today's copy.
 */
const InterviewStepper = ({ activeIndex, labels = null }) => {
    const L = { ...INTERVIEW_STEPPER_LABELS, ...(labels || {}) };

    return (
        <ol className="interview-stepper" aria-label={L.progress}>
            {L.steps.map((label, index) => {
                const state = index < activeIndex ? 'done' : index === activeIndex ? 'active' : 'upcoming';
                return (
                    <li
                        key={label}
                        className={`stepper-step is-${state}`}
                        aria-current={state === 'active' ? 'step' : undefined}
                    >
                        <span className="stepper-marker" aria-hidden="true">
                            {state === 'done' ? <Check size={12} /> : index + 1}
                        </span>
                        <span className="stepper-label">{label}</span>
                    </li>
                );
            })}
        </ol>
    );
};

export default InterviewStepper;
